export default __webpack_public_path__ + "static/media/icons8-python.131acef2.png";